import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { BodyFour, BodyThree } from '../../../../styles/theme/default/typography';
import Fabrics from './Fabrics';
import FilterButton from './filters/FilterButton';
import Filters from './filters/Filters';

const Wrapper = styled.div`
  width: 420px;
  right: 0;
  background: white;
  position: fixed;
  top: 0;
  z-index: 1010;
  overflow: auto;
  padding-bottom: 100px;

  .filter-btn-stock-only {
    display: flex;
    align-items: baseline;
    justify-content: space-between;

    padding: 0 15px;
    margin-top: 20px;
  }

  .head-container {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #d8d8d8;
    padding: 20px 15px;

    .select-fabric,
    .back-btn,
    .holder {
      flex: 1;
    }
  }

  .stock-only-clear-all-container {
    .clear-all {
      cursor: pointer;
      text-align: end;
      margin-top: 15px;
    }
  }

  .footer-container {
    position: fixed;
    bottom: 0;
    width: 100%;

    background: white;
    border-top: 1px solid #d8d8d8;
    padding-top: 15px;
    .selected-fabric {
      margin-bottom: 15px;
      padding: 0 15px;
    }

    .buttons-container {
      width: 100%;
      button {
        width: 100%;
        height: 56px;
      }
    }
  }

  @media (max-width: 992px) {
    width: 100%;
    top: 0px;
    height: calc(100% - 0px);
  }
`;

const getIds = arrayWithIds => {
  return arrayWithIds.map(arrayWithIds => arrayWithIds.id);
};

function FilterSidebar({
  open,
  setSelectedFabric,
  selectedFabric,
  fabrics,
  setOpen,
  patternIds,
  setPatternIds,
  patterns,
  materials,
  materialIds,
  setMaterialIds,
  colors,
  colorIds,
  setColorIds
}) {
  const [showFilters, setShowFilters] = useState(false);

  const fabricSidebarRef = useRef(null);

  const clearFilters = () => {
    setMaterialIds([]);
    setPatternIds([]);
    setColorIds([]);
  };

  const showClearFiltersButton =
    materialIds.length || patternIds.length || colorIds.length;

  const totalFiltersApplied = [...materialIds, ...patternIds, ...colorIds]
    .length;

  if (showFilters) {
    return (
      <Wrapper>
        <Filters
          colors={colors}
          setColorIds={setColorIds}
          colorIds={colorIds}
          materials={materials}
          materialIds={materialIds}
          setMaterialIds={setMaterialIds}
          patterns={patterns}
          patternIds={patternIds}
          setPatternIds={setPatternIds}
          clearFilters={clearFilters}
          showClearFiltersButton={showClearFiltersButton}
          toggle={() => setShowFilters(!showFilters)}
          totalFabricResults={fabrics?.length}
        />
      </Wrapper>
    );
  }

  const fabricFullName = `${selectedFabric?.name}${
    selectedFabric?.collaborator
      ? ` by ${selectedFabric?.collaborator?.name}`
      : ''
  }`;

  return (
    <Wrapper open={open} ref={fabricSidebarRef}>
      <div className="head-container">
        <BackText className="back-btn" onClick={() => setOpen(false)}>
          {'<'} Back
        </BackText>
        <Title className="select-fabric">Select Fabric</Title>
        <div className="holder" />
      </div>

      <div className="body-container">
        <div className="filter-btn-stock-only">
          <FilterButton
            totalItemsFilters={totalFiltersApplied}
            onClick={() => setShowFilters(!showFilters)}
          />
          <div className="stock-only-clear-all-container">
            {showClearFiltersButton ? (
              <BodyThree
                className="clear-all"
                onClick={clearFilters}
                color="#A83569"
              >
                Clear All
              </BodyThree>
            ) : (
              ''
            )}
          </div>
        </div>

        {/* <div className="filters-container">
          <div className="filter-clear-container">
            <div
              onClick={() => setShowFilters(!showFilters)}
              className="filter-text-arrow"
            >
              <Text className="show-filter-text">
                {showFilters ? 'Hide Filters' : 'Show Filters'}
              </Text>

              {showFilters ? (
                <img
                  src="/assets/pdp/arrow-up.svg"
                  alt="add one less to cart"
                />
              ) : (
                <img
                  src="/assets/pdp/arrow-down.svg"
                  alt="add one less to cart"
                />
              )}
            </div>
            {showClearFiltersButton ? (
              <ClearText onClick={clearFilters}>Clear All</ClearText>
            ) : (
              ''
            )}
          </div>
          {showFilters && (
            <OldFilters
              colors={colors}
              setColorIds={setColorIds}
              colorIds={colorIds}
              materials={materials}
              materialIds={materialIds}
              setMaterialIds={setMaterialIds}
              patterns={patterns}
              patternIds={patternIds}
              setPatternIds={setPatternIds}
            />
          )} 
        </div>
        */}
        <Fabrics
          setSelectedFabric={setSelectedFabric}
          selectedFabric={selectedFabric}
          fabrics={fabrics}
        />
      </div>
      <div className="footer-container">
        <BodyFour className="selected-fabric">
          Selected: {fabricFullName}
        </BodyFour>
        <div className="buttons-container">
          <Button
            onClick={() => {
              setOpen(false);
            }}
          >
            Save Selection
          </Button>
        </div>
      </div>
    </Wrapper>
  );
}

export default FilterSidebar;

const ClearText = styled.div`
  cursor: pointer;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.04em;
  cursor: pointer;
  color: #a83569;
`;

const BackText = styled.div`
  cursor: pointer;

  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 23px;
  color: #6c6c6c;

  @media (max-width: 992px) {
    font-size: 14px;
    line-height: 17px;
  }
`;

const Title = styled.div`
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;

  @media (max-width: 992px) {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.04em;

    color: ${({ theme }) => theme.colors.charcoal};
  }
`;

const Text = styled.div`
  text-align: center;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 25px;

  @media (max-width: 992px) {
    font-size: 14px;
    line-height: 17px;

    letter-spacing: 0.04em;
  }
`;

const Button = styled.button`
  background: ${({ light }) => (light ? 'white' : 'black')};
  color: ${({ light, theme }) => (light ?  theme.colors.charcoal: 'white')};
  border: 1px solid black;
  height: 50px;

  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  /* identical to box height, or 144% */

  letter-spacing: 0.04em;

  opacity: 0.9;

  @media (max-width: 992px) {
    font-size: 14px;
    line-height: 17px;
    height: 45px;
    letter-spacing: 0.04em;
  }
`;
